import * as React from 'react';
import { FC, useEffect, useState } from 'react';
import { editMarketContent, getMarketContentBySymbol } from '../../../../../../../core/repositories/manage-market';
import { Link, useLocation } from 'react-router-dom';
import { Card } from '../../../../../../../components/card/card';
import { Button, buttonType } from '../../../../../../../components/button/button';
import { FileOutlined } from '@ant-design/icons';
import { ColorPicker, Divider, Image, Row, Switch, Typography, Upload, UploadProps } from 'antd';
import { RcFile } from 'antd/es/upload';
import { toast } from 'react-hot-toast';
import './content.scss';
import { API_URL, TinyEditorAPIKey, WEBSITE_URL } from '../../../../../../../core/constants/constants';
import TextArea from 'antd/lib/input/TextArea';
import Dragger from 'antd/es/upload/Dragger';
import { Input } from '../../../../../../../components/input/input';
import { Editor } from 'components/editor/editor';
import { Badge } from 'components';
import { MarketContent } from 'core/domain/manage-market/manage-market';

export const EditMarketContent: FC = (props) => {
    const [body, setBody] = useState<MarketContent>({
        description1: '',
        description2: '',
        content: '',
        coin3DImageUrl: '',
        coin3DImageUrlFile: '',
        coinColor: '',
        heroBackGroundImageUrl: '',
        heroBackGroundImageUrlFile: '',
        videoEmbed: '',
        customScript: '',
        metaTitle: '',
        metaDescription: '',
        noIndex: false,
        canonicalLink: '',
    });
    const [loading, setLoading] = useState<boolean>(false);
    const [buttonLoading, setButtonLoading] = useState<boolean>(false);

    const [coin3DImagePreview, setCoin3DImagePreview] = useState<string | null>(null);
    const [heroBackgroundImagePreview, setHeroBackgroundImagePreview] = useState<string | null>(null);

    const [coin3DImagePreviewVisible, setCoin3DImagePreviewVisible] = useState<boolean>(false);
    const [heroBackgroundImagePreviewVisible, setHeroBackgroundImagePreviewVisible] = useState<boolean>(false);

    const location = useLocation();
    const marketSymbol = location.pathname.split('/')[location.pathname.split('/').length - 1];

    const handleEditContent = () => {
        editMarketContent(setButtonLoading, body, marketSymbol);
    };

    useEffect(() => {
        getMarketContentBySymbol(setLoading, setBody, marketSymbol);
    }, [marketSymbol]);

    const coin3dImagefileUploadProps: UploadProps = {
        name: 'file-uploader',
        className: 'file-uploader',
        onRemove: () => {
            setBody({
                ...body,
                coin3DImageUrlFile: '',
            });
            setCoin3DImagePreview(null);
            return true;
        },
        beforeUpload: (file: RcFile) => {
            const isCorrectFormat =
                file.type === 'image/png' || file.type === 'image/jpeg' || file.type === 'image/jpg';
            if (!isCorrectFormat) {
                toast.error(`فرمت تصویر آپلود شده صحیح نمی باشد.`);
                return Upload.LIST_IGNORE as unknown as boolean;
            }

            setBody({
                ...body,
                coin3DImageUrlFile: file,
            });
            setCoin3DImagePreview(URL.createObjectURL(file));

            return false;
        },
        multiple: false,
        showUploadList: false,
    };

    const handleImageUpload = (blobInfo, progress): Promise<string> => {
        const reader = new FileReader();
        reader.readAsDataURL(blobInfo);
        return new Promise((resolve, reject) => {
            reader.onloadend = () => {
                const base64data = reader.result as string;
                resolve(base64data);

                reject('آپلود عکس ناموفق بود');
            };
        });
    };

    const coinBgImageFileUploadProps: UploadProps = {
        name: 'file-uploader',
        className: 'file-uploader',
        onRemove: () => {
            setBody({
                ...body,
                heroBackGroundImageUrlFile: '',
            });
            setHeroBackgroundImagePreview(null);
            return true;
        },
        beforeUpload: (file: RcFile) => {
            const isCorrectFormat =
                file.type === 'image/png' || file.type === 'image/jpeg' || file.type === 'image/jpg';
            if (!isCorrectFormat) {
                toast.error(`فرمت تصویر آپلود شده صحیح نمی باشد.`);
                return Upload.LIST_IGNORE as unknown as boolean;
            }

            setBody({
                ...body,
                heroBackGroundImageUrlFile: file,
            });
            setHeroBackgroundImagePreview(URL.createObjectURL(file));

            return false;
        },
        multiple: false,
        showUploadList: false,
    };

    return (
        <Card blur={loading} className={'content-market-stage'}>
            <Row className="website-row">
                <label>آدرس صفحه انتخابی:</label>
                <Link
                    to={`${WEBSITE_URL}coins/${marketSymbol.toUpperCase()}`}
                    target="_blank"
                    className="website-url en"
                >
                    {`${WEBSITE_URL}coins/${marketSymbol.toUpperCase()}`}
                </Link>
            </Row>
            <Divider />
            <Row>
                <label>عنوان متا</label>
                <TextArea
                    value={body?.metaTitle}
                    dir={body?.metaTitle ? 'ltr' : 'rtl'}
                    placeholder={'عنوان متا را وارد کنید'}
                    onChange={(e) => setBody({ ...body, metaTitle: e.target.value })}
                />
            </Row>
            <br />
            <br />
            <Row>
                <label>توضیحات متا</label>
                <TextArea
                    value={body?.metaDescription}
                    dir={body?.metaDescription ? 'ltr' : 'rtl'}
                    placeholder={'توضیحات متا را وارد کنید'}
                    onChange={(e) => setBody({ ...body, metaDescription: e.target.value })}
                />
            </Row>
            <br />
            <br />
            <Row>
                <label>لینک کنونیکال (Canonical Link)</label>
                <TextArea
                    autoSize
                    value={body?.canonicalLink}
                    dir={body?.canonicalLink ? 'ltr' : 'rtl'}
                    placeholder={'لینک کنونیکال را وارد کنید'}
                    onChange={(e) => setBody({ ...body, canonicalLink: e.target.value })}
                />
            </Row>
            <br />
            <br />
            <Row>
                <label>توضیحات بخش ۱ :</label>

                <TextArea
                    value={body?.description1}
                    placeholder={'توضیحات ۱'}
                    onChange={(e) => setBody({ ...body, description1: e.target.value })}
                    dir={body.description1 ? 'rtl' : 'ltr'}
                />
            </Row>
            <Divider />

            <Row>
                <label>توضیحات بخش ۲ :</label>

                <TextArea
                    value={body?.description2}
                    placeholder={'توضیحات ۲'}
                    onChange={(e) => setBody({ ...body, description2: e.target.value })}
                    dir={body.description2 ? 'rtl' : 'ltr'}
                />
            </Row>
            <Divider />

            <Row className={'color'}>
                <label>رنگ ارز : </label>
                <ColorPicker
                    value={
                        body.coinColor
                            ? body.coinColor.startsWith('#')
                                ? body.coinColor
                                : `#${body.coinColor}`
                            : undefined
                    }
                    onChange={(color) => {
                        setBody({
                            ...body,
                            coinColor: color.toHexString(),
                        });
                    }}
                    defaultValue="#1677ff"
                    showText
                    allowClear
                    size="large"
                />
            </Row>
            <Divider />
            <Row className={'textarea row'}>
                <label>محتوا ارز :</label>
                <Editor value={body?.content || ''} onChange={(content) => setBody((prev) => ({ ...prev, content }))} />
            </Row>
            <Divider />
            {/*{body.heroBackGroundImageUrlFile && (*/}
            {/*  <Row className={"row"}>*/}
            {/*    <label>تصویر بکگراند ارز</label>*/}
            {/*    <Image src={`${SERVER_URL}${body.heroBackGroundImageUrlFile}`} />*/}
            {/*  </Row>*/}
            {/*)}*/}
            <Row className={'row uploader-row'}>
                <Dragger {...coin3dImagefileUploadProps}>
                    <button className="upload-button" onClick={(el) => el.preventDefault()}>
                        <FileOutlined />
                        <p>آپلود تصویر سه بعدی ارز</p>
                    </button>
                </Dragger>
                {coin3DImagePreview || body.coin3DImageUrl ? (
                    <Image
                        src={coin3DImagePreview || `${API_URL}${body.coin3DImageUrl}`}
                        style={{
                            width: 100,
                            height: 100,
                            objectFit: 'cover',
                            marginTop: 10,
                        }}
                        preview={{
                            visible: coin3DImagePreviewVisible,
                            onVisibleChange: () => {
                                setCoin3DImagePreviewVisible(!coin3DImagePreviewVisible);
                            },
                        }}
                    />
                ) : null}
            </Row>
            <Row className={'row uploader-row'}>
                <Dragger {...coinBgImageFileUploadProps}>
                    <button className="upload-button" onClick={(el) => el.preventDefault()}>
                        <FileOutlined />
                        <p>آپلود تصویر بک گراند ارز</p>
                    </button>
                </Dragger>
                {heroBackgroundImagePreview || body.heroBackGroundImageUrl ? (
                    <Image
                        src={heroBackgroundImagePreview || `${WEBSITE_URL}${body.heroBackGroundImageUrl}`}
                        style={{
                            width: 100,
                            height: 100,
                            objectFit: 'cover',
                            marginTop: 10,
                        }}
                        preview={{
                            visible: heroBackgroundImagePreviewVisible,
                            onVisibleChange: () => {
                                setHeroBackgroundImagePreviewVisible(!heroBackgroundImagePreviewVisible);
                            },
                        }}
                    />
                ) : null}
            </Row>
            <br />
            <br />
            <Row>
                <label>لینک ویدئو</label>
                <TextArea
                    value={body?.videoEmbed}
                    dir={body?.videoEmbed ? 'ltr' : 'rtl'}
                    placeholder={'لینک ویدئو را وارد کنید'}
                    onChange={(e) => setBody({ ...body, videoEmbed: e.target.value })}
                />
            </Row>
            <br />
            <br />
            <Row>
                <label>اسکریپت شخصی سازی شده</label>
                <TextArea
                    value={body?.customScript}
                    dir={body?.customScript ? 'ltr' : 'rtl'}
                    placeholder={'اسکریپت را وارد کنید'}
                    onChange={(e) => setBody({ ...body, customScript: e.target.value })}
                />
            </Row>
            <br />
            <br />
            <Row>
                <label>No Index</label>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <Switch
                    checked={body?.noIndex}
                    checkedChildren={'No Index فعال'}
                    unCheckedChildren={'No Index غیرفعال'}
                    onChange={(checked) =>
                        setBody({
                            ...body,
                            noIndex: checked,
                        })
                    }
                />
            </Row>
            <Button
                type={buttonType.info}
                text={'ویرایش محتوای ارز'}
                onClick={handleEditContent}
                loading={buttonLoading}
                disabled={buttonLoading}
            />
            <Link to={'/dashboard/content/manage-markets'}>
                <Button type={buttonType.primary} text={'بازگشت به صفحه محتواهای ارزها'} />
            </Link>
        </Card>
    );
};
